import React from "react";
import { Command } from "react-mde";
import { formatMessage } from "lib/globalize-util";
import { TermsModal } from "./terms-modal";
import { IBrandTerms } from "./hooks";
import { TermsAndConditionsEditor, Tabs } from "./terms-and-conditions-editor";

const TOOLBAR_COMMANDS = [
    ["header", "bold", "italic", "strikethrough"],
    ["link", "quote", "code"],
    ["unordered-list", "ordered-list", "checked-list"],
    ["preview-modal"],
];

interface ITermsProps {
    termsContent: string;
    onChangeTerms: (terms: string) => void;
    terms: IBrandTerms;
}

export const TermsAndConditions: React.FunctionComponent<ITermsProps> = ({ termsContent, onChangeTerms, terms }) => {
    const [selectedTab, setSelectedTab] = React.useState<"write" | "preview">(Tabs.Write);
    const [openPreviewModal, setOpenPreviewModal] = React.useState<boolean>(false);

    const previewModal: Command = React.useMemo(() => {
        return {
            icon: () => formatMessage("Preview Modal"),
            execute: (opts) => {
                setOpenPreviewModal(true);
            },
        };
    }, []);

    const handleClosePreviewModal = React.useCallback(() => {
        setOpenPreviewModal(false);
    }, []);

    return (
        <React.Fragment>
            <TermsAndConditionsEditor
                value={termsContent}
                onChange={onChangeTerms}
                selectedTab={selectedTab}
                onTabChange={setSelectedTab}
                commands={{
                    "preview-modal": previewModal,
                }}
                toolbarCommands={TOOLBAR_COMMANDS}
            />
            {openPreviewModal && <TermsModal open={openPreviewModal} onClose={handleClosePreviewModal} terms={terms} />}
        </React.Fragment>
    );
};
